import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import Panel from '../../../../shared-components/Panel';
import styles from './blog.module.sass';
import {
  Typography,
  Row,
  Col,
  Button,
  Select,
  Pagination,
  Input,
  Space,
  Popover,
} from 'antd';
import { RightOutlined, SearchOutlined, MoreOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import cx from 'classnames';
import BlogContent from '../BlogContent';
import { STATUS } from '../../../../redux/constants';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function Blog(props) {
  const {
    availableBlogsStatus,
    availableBlogs,
    blogStatus,
    blog,
    amberReportFeeds,
    amberReportFeedsStatus,
    amberReportTags,
    amberReportTagsStatus,
    amberReportCount,
    //for filter pivoting
    closeFilterSidebar,
    applyFilters,
    updateTag,
    updateIocList,
    threatRankingListPagination,
    threatRankingListSorting,
  } = props;
  const { Title, Text } = Typography;
  const [markAllAsSeenVisible, setMarkAllAsSeenVisible] = useState(false);

  const [postOpened, setPostOpened] = useState(false);
  const currentPage = useRef(1);
  const history = useHistory();

  const q = useQuery();
  const dispatch = useDispatch();
  const { Search } = Input;

  const [dataState, setDataState] = useState({
    titleSearchValue: '',
    feedSearchValue: undefined,
    tagSearchValue: undefined,
    kick_search_off: false,
  });

  useEffect(() => {
    document.title = `TLP Amber Reports - Silent Push`;
    if (
      props?.mySubscriptionPlan?.has_access_to_tlp_amber_report &&
      props.mySubscriptionPlanStatus === STATUS.LOADED
    ) {
      fetchData();
      props.loadAmberReportFeeds();
      props.loadAmberReportTags();
    }
  }, [props.mySubscriptionPlanStatus]);

  useEffect(() => {
    const postName = q?.get('post');
    const feedName = q?.get('name');

    if (postName) {
      setPostOpened(true);
    } else {
      setPostOpened(false);
      if (amberReportCount?.count === 0) {
        setMarkAllAsSeenVisible(false);
      }
      changeBlogTitle('TLP Amber Reports');
      document.title = `TLP Amber Reports - Silent Push`;
    }

    if (feedName) {
      setDataState({
        ...dataState,
        feedSearchValue: feedName,
        kick_search_off: true,
      });
    }
  }, [window.location.search]);

  // Any filtering input change triggers this except for filter by title and assembles the filter url
  useEffect(() => {
    if (availableBlogsStatus === STATUS.LOADED) {
      if (q?.get('name') && dataState?.feedSearchValue === undefined) {
        return;
      }
      if (dataState?.kick_search_off) {
        fetchData();
      }
    }
  }, [dataState]);

  useEffect(() => {
    // show mark as read button if there is an unread report
    if (
      availableBlogs?.results?.length > 0 &&
      availableBlogsStatus === STATUS.LOADED
    ) {
      for (let i in availableBlogs?.results) {
        if (availableBlogs.results[i].isSeen === false) {
          setMarkAllAsSeenVisible(true);
          break;
        }
      }
    }
  }, [availableBlogsStatus]);

  const fetchData = () => {
    let filterParams = '?page=' + currentPage.current;
    if (dataState?.titleSearchValue) {
      filterParams += '&title=' + dataState?.titleSearchValue;
    }
    if (dataState?.feedSearchValue) {
      filterParams += '&feeds=' + dataState?.feedSearchValue;
    } else if (q?.get('name')) {
      filterParams += '&feeds=' + q?.get('name');
    }
    if (dataState?.tagSearchValue) {
      filterParams += '&tags=' + dataState?.tagSearchValue;
    }
    props.filterAmberReports(filterParams);
    incrementUIRequestsCounter();
  };

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  function handleReadMore(name, uuid) {
    history.push(`/blog?post=${name}&uuid=${uuid}`);

    if (availableBlogs?.results?.length > 0) {
      for (let i in availableBlogs.results) {
        if (availableBlogs.results[i]?.uuid === uuid) {
          if (availableBlogs.results[i]?.isSeen === false) {
            props.setAmberReportSeen(uuid);
            break;
          }
        }
      }
    }
  }

  function changeBlogTitle(title) {
    dispatch(changeTitle(title, null));
  }

  const handleTitleSearch = () => {
    currentPage.current = 1;
    setDataState({
      ...dataState,
      kick_search_off: true,
    });
  };

  const handleTitleSearchChange = (e) => {
    currentPage.current = 1;
    if (e.target.value === '') {
      setDataState({
        ...dataState,
        titleSearchValue: e.target.value,
        kick_search_off: true,
      });
    } else {
      setDataState({
        ...dataState,
        titleSearchValue: e.target.value,
        kick_search_off: false,
      });
    }
  };

  const returnFeedLink = (uuid, name) => {
    return (
      <Link
        to={'/?feed=' + uuid}
        className={'ms-05'}
        onClick={() => {
          closeFilterSidebar();
          applyFilters(null);
          updateTag(null);
          updateIocList({
            pagination: threatRankingListPagination,
            sorting: threatRankingListSorting,
            filters: {
              feed: [uuid],
            },
          });
        }}
      >
        {name}
      </Link>
    );
  };

  const setTagSearchValue = (tags) => {
    setDataState({
      ...dataState,
      tagSearchValue: tags,
      kick_search_off: true,
    });
  };

  const handleFeedSearch = (value) => {
    if (value?.length === 0) {
      window.history.replaceState(null, '', '/blog');
    }
    let feeds = [];
    if (value?.length > 0) {
      value.forEach((feed) => feeds.push(feed));
    }
    feeds = feeds ? feeds : undefined;
    setDataState({
      ...dataState,
      feedSearchValue: feeds,
      kick_search_off: true,
    });
    currentPage.current = 1;
  };

  const handleTagSearch = (value) => {
    let tags = [];
    if (value?.length > 0) {
      value.forEach((val) => tags.push(val));
    }
    tags = tags ? tags : undefined;
    setDataState({
      ...dataState,
      tagSearchValue: tags,
      kick_search_off: true,
    });
    currentPage.current = 1;
  };

  const clearFilters = () => {
    setDataState({
      titleSearchValue: '',
      feedSearchValue: undefined,
      tagSearchValue: undefined,
      kick_search_off: true,
    });
    currentPage.current = 1;
    window.history.replaceState(null, '', '/blog');
  };

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan?.has_access_to_tlp_amber_report ? (
      <div className={styles.blog}>
        {!postOpened && (
          <>
            <Row
              gutter={24}
              justify="space-between"
              className={styles.topActions}
            >
              <Col className={styles.filters}>
                <Space className={styles.filtersSpace}>
                  <Search
                    className={styles.titleInput}
                    placeholder="Search reports"
                    onSearch={handleTitleSearch}
                    onChange={handleTitleSearchChange}
                    value={dataState?.titleSearchValue}
                    allowClear
                    data-cy="blogTitleFilterField"
                  />
                  <Select
                    className={styles.input}
                    mode="multiple"
                    onChange={handleFeedSearch}
                    value={dataState?.feedSearchValue}
                    tokenSeparators={[', ']}
                    options={amberReportFeeds}
                    placeholder="Filter by feed"
                    loading={amberReportFeedsStatus === STATUS.LOADING}
                    filterOption={(inputValue, option) => {
                      return (
                        option?.label
                          ?.toLowerCase()
                          ?.indexOf(inputValue?.toLowerCase()) > -1
                      );
                    }}
                    data-cy="blogFeedFilterField"
                  />
                  <Select
                    className={styles.input}
                    mode="multiple"
                    onChange={handleTagSearch}
                    value={dataState?.tagSearchValue}
                    tokenSeparators={[', ']}
                    options={amberReportTags}
                    placeholder="Filter by tags"
                    loading={amberReportTagsStatus === STATUS.LOADING}
                    data-cy="blogTagsFilterField"
                  />
                </Space>

                <Button
                  className="ms-05"
                  type="link"
                  onClick={() => {
                    clearFilters();
                  }}
                >
                  Clear filters
                </Button>

                {markAllAsSeenVisible && (
                  <Button
                    className="ms-05"
                    type="link"
                    onClick={() => {
                      props.setAmberReportsAsSeen();
                      setMarkAllAsSeenVisible(false);
                      incrementUIRequestsCounter();
                    }}
                  >
                    Mark All as Read
                  </Button>
                )}
              </Col>

              <Col>
                <Pagination
                  className={styles.topPagination}
                  showSizeChanger={false}
                  current={currentPage.current}
                  total={availableBlogs?.count}
                  pageSize={10}
                  pageLoading={availableBlogsStatus === STATUS.LOADING}
                  onChange={(current) => {
                    window.scrollTo(0, 0);
                    currentPage.current = current;
                    fetchData();
                  }}
                />
              </Col>
            </Row>

            {availableBlogsStatus === STATUS.LOADED &&
            blogStatus !== STATUS.LOADING ? (
              <>
                {availableBlogs?.results?.length === 0 && (
                  <div className={styles.noResult}>
                    <div className={styles.content}>
                      <SearchOutlined />
                      <Title level={3}>No Results</Title>
                      <Text>There are no reports matching your filters.</Text>
                    </div>
                  </div>
                )}
                {availableBlogs?.results?.map((blog) => (
                  <Panel
                    key={blog?.uuid}
                    className={cx(styles.panel, {
                      [styles.new]: !blog?.isSeen,
                    })}
                    bgcolor={blog?.isSeen ? '#1C3138' : '#243F47'}
                  >
                    <Row gutter={24}>
                      <Col xs={24} className={styles.blogHeader}>
                        <div>
                          <Title
                            className={styles.reportTitle}
                            level={3}
                            onClick={() => {
                              handleReadMore(
                                blog?.title?.toLowerCase()?.replace(' ', '-'),
                                blog?.uuid,
                              );
                            }}
                          >
                            {blog?.title}
                          </Title>
                        </div>

                        {blog?.feedsData?.length > 0 && (
                          <div>
                            <Title level={5}>Related Feed(s):</Title>
                            {blog?.feedsData?.length > 2 ? (
                              <Popover
                                placement="left"
                                content={blog?.feedsData?.map(
                                  (feed, index) =>
                                    feed &&
                                    index > 1 && (
                                      <>
                                        {returnFeedLink(feed?.uuid, feed?.name)}
                                        {blog?.feedsData?.length > 1 &&
                                          index !==
                                            blog?.feedsData?.length - 1 &&
                                          ','}
                                      </>
                                    ),
                                )}
                              >
                                {blog?.feedsData?.map(
                                  (feed, index) =>
                                    feed &&
                                    index <= 1 && (
                                      <>
                                        {returnFeedLink(feed?.uuid, feed?.name)}
                                        {blog?.feedsData?.length > 1 &&
                                          index !==
                                            blog?.feedsData?.length - 1 &&
                                          ','}
                                      </>
                                    ),
                                )}{' '}
                                <MoreOutlined />
                              </Popover>
                            ) : (
                              blog?.feedsData?.map(
                                (feed, index) =>
                                  feed && (
                                    <>
                                      {returnFeedLink(feed?.uuid, feed?.name)}
                                      {blog?.feedsData?.length > 1 &&
                                        index !== blog?.feedsData?.length - 1 &&
                                        ','}
                                    </>
                                  ),
                              )
                            )}
                          </div>
                        )}
                      </Col>

                      {blog?.excerpt && (
                        <Col xs={24} className={styles.blogBody}>
                          <Text>{blog.excerpt}...</Text>
                        </Col>
                      )}

                      <Col xs={24} xl={16} className={styles.blogFooter}>
                        <div className={styles.postInfo}>
                          <div className={styles.info}>
                            <Title level={5}>Published:</Title>
                            <Text className="ms-05">
                              {moment(blog?.date).format('YYYY-MM-DD HH:mm')}
                            </Text>
                          </div>
                          <div className={styles.info}>
                            <Title level={5}>Tags:</Title>

                            {blog?.tagsData?.length > 3 ? (
                              <Popover
                                content={blog?.tagsData?.map(
                                  (tag, index) =>
                                    tag &&
                                    index > 2 && (
                                      <Text className="ms-05">
                                        <a
                                          style={{ color: '#FEBF00' }}
                                          onClick={(e) =>
                                            setDataState({
                                              ...dataState,
                                              tagSearchValue:
                                                e.target.innerText,
                                              kick_search_off: true,
                                            })
                                          }
                                        >
                                          {tag.tag}
                                        </a>
                                        {blog?.tagsData?.length > 1 &&
                                          index !==
                                            blog?.tagsData?.length - 1 &&
                                          ','}
                                      </Text>
                                    ),
                                )}
                              >
                                {blog?.tagsData?.map(
                                  (tag, index) =>
                                    tag &&
                                    index <= 2 && (
                                      <Text className="ms-05">
                                        <a
                                          className={styles.tag}
                                          onClick={(e) =>
                                            setDataState({
                                              ...dataState,
                                              tagSearchValue:
                                                e.target.innerText,
                                              kick_search_off: true,
                                            })
                                          }
                                        >
                                          {tag.tag}
                                        </a>
                                        {blog?.tagsData?.length > 1 &&
                                          index !==
                                            blog?.tagsData?.length - 1 &&
                                          ','}
                                      </Text>
                                    ),
                                )}{' '}
                                <MoreOutlined />
                              </Popover>
                            ) : (
                              blog?.tagsData?.map(
                                (tag, index) =>
                                  tag && (
                                    <Text className="ms-05">
                                      <a
                                        className={styles.tag}
                                        onClick={(e) =>
                                          setDataState({
                                            ...dataState,
                                            tagSearchValue: e.target.innerText,
                                            kick_search_off: true,
                                          })
                                        }
                                      >
                                        {tag.tag}
                                      </a>
                                      {blog?.tagsData?.length > 1 &&
                                        index !== blog?.tagsData?.length - 1 &&
                                        ','}
                                    </Text>
                                  ),
                              )
                            )}

                            {blog?.tagsData?.length === 0 && (
                              <Text strong className="ms-05">
                                -
                              </Text>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col xs={24} xl={8} className={styles.buttonColumn}>
                        {blog?.isSeen && (
                          <Button
                            type="link"
                            onClick={() => {
                              props.setAmberReportUnseen(blog?.uuid);
                              incrementUIRequestsCounter();
                            }}
                          >
                            Mark as Unread
                          </Button>
                        )}

                        <Button
                          className={'ms-05'}
                          onClick={() => {
                            handleReadMore(
                              blog?.title?.toLowerCase()?.replace(' ', '-'),
                              blog?.uuid,
                            );
                            incrementUIRequestsCounter();
                          }}
                        >
                          Read More <RightOutlined />
                        </Button>
                      </Col>
                    </Row>

                    <div className={styles.customBackground}></div>
                  </Panel>
                ))}
              </>
            ) : (
              <>
                <Panel
                  className={cx(styles.panel, styles.skeleton)}
                  bgcolor={'#1C3138'}
                >
                  <Row gutter={24}>
                    <Col xs={24} className={styles.blogHeader}>
                      <div className={styles.titleSkeleton}>
                        <LoadingSkeleton />
                      </div>

                      <div className={styles.feedSkeleton}>
                        <LoadingSkeleton />
                      </div>
                    </Col>

                    <Col xs={24} className={styles.blogFooter}>
                      <div className={styles.postInfo}>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                      </div>

                      <div className={styles.readSkeleton}>
                        <LoadingSkeleton />
                      </div>
                    </Col>
                  </Row>

                  <div className={styles.customBackground}></div>
                </Panel>
                <Panel
                  className={cx(styles.panel, styles.skeleton)}
                  bgcolor={'#1C3138'}
                >
                  <Row gutter={24}>
                    <Col xs={24} className={styles.blogHeader}>
                      <div className={styles.titleSkeleton}>
                        <LoadingSkeleton />
                      </div>

                      <div className={styles.feedSkeleton}>
                        <LoadingSkeleton />
                      </div>
                    </Col>

                    <Col xs={24} className={styles.blogFooter}>
                      <div className={styles.postInfo}>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                      </div>

                      <div className={styles.readSkeleton}>
                        <LoadingSkeleton />
                      </div>
                    </Col>
                  </Row>

                  <div className={styles.customBackground}></div>
                </Panel>
                <Panel
                  className={cx(styles.panel, styles.skeleton)}
                  bgcolor={'#1C3138'}
                >
                  <Row gutter={24}>
                    <Col xs={24} className={styles.blogHeader}>
                      <div className={styles.titleSkeleton}>
                        <LoadingSkeleton />
                      </div>

                      <div className={styles.feedSkeleton}>
                        <LoadingSkeleton />
                      </div>
                    </Col>

                    <Col xs={24} className={styles.blogFooter}>
                      <div className={styles.postInfo}>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                        <div className={styles.info}>
                          <LoadingSkeleton />
                        </div>
                      </div>

                      <div className={styles.readSkeleton}>
                        <LoadingSkeleton />
                      </div>
                    </Col>
                  </Row>

                  <div className={styles.customBackground}></div>
                </Panel>
              </>
            )}

            <Row gutter={24} justify="end" className={styles.bottomActions}>
              <Col>
                <Pagination
                  showSizeChanger={false}
                  current={currentPage.current}
                  total={availableBlogs?.count}
                  pageSize={10}
                  pageLoading={availableBlogsStatus === STATUS.LOADING}
                  onChange={(current, pageSize) => {
                    window.scrollTo(0, 0);
                    currentPage.current = current;
                    fetchData();
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {postOpened && (
          <BlogContent
            blogStatus={blogStatus}
            blog={blog}
            amberReportFeeds={amberReportFeeds}
            setTagSearchValue={setTagSearchValue}
            changeBlogTitle={changeBlogTitle}
            closeFilterSidebar={closeFilterSidebar}
            applyFilters={applyFilters}
            updateTag={updateTag}
            updateIocList={updateIocList}
            threatRankingListPagination={threatRankingListPagination}
            threatRankingListSorting={threatRankingListSorting}
            loadAmberReport={props.loadAmberReport}
            mySubscriptionPlan={props.mySubscriptionPlan}
            websocketConnection={props?.websocketConnection}
          />
        )}
      </div>
    ) : (
      <PermissionDeniedPage />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default Blog;
